
import routesPath from "@/config/routesPath";
import common from "@/config/common";
import TokenService from "@/services/tokenService";
import { defineComponent } from "vue";
import { mapGetters, mapMutations } from "vuex";
import messages from "@/config/messages";
import eventBus from "@/utils/eventBus";

export default defineComponent({
  name: "AppHeader",
  data() {
    return {
      routesPath,
      showMobileMenu: false,
      originalMenuItems: [
        {
          link: "enrollments",
          title: "Enrollments",
          icon: "profile",
          priority: 1,
        },
        {
          link: "profile-information",
          title: "Profile Info",
          icon: "profile",
          priority: 2,
        },
        {
          link: "dependents",
          title: "Dependents",
          icon: "dependents",
          priority: 3,
        },
        {
          link: "benefits",
          title: "Benefits",
          icon: "benefits",
          priority: 4,
        },
        {
          link: "documents",
          title: "Documents",
          icon: "document",
          priority: 5,
        },
        {
          link: "confirmation",
          title: "Confirmation",
          icon: "confirmation",
          priority: 6,
        },
        {
          link: "payments",
          title: "Payments",
          icon: "payment",
          priority: 7,
        },
      ],
      menuItems: [] as Array<{
        link: string;
        title: string;
        icon: string;
        priority: number;
      }>,
      isPaymentCard: false,
    };
  },
  computed: {
    isSubmitted: () =>
      sessionStorage.getItem(common.storageVariables.isSubmitted) === "yes",
    ...mapGetters(["getFormDirty", "getEnrollment", "getTotalEnrollments"]),
    visibleMenuItems() {
      return this.menuItems;
    },
  },
  watch: {
    $route(to, from) {
      this.showMobileMenu = false;
      localStorage.setItem(common.storageVariables.currentRoute, to.name);
    },
  },
  created() {
    this.menuItems = this.originalMenuItems.slice();
    const currentRouteName = this.$route.name;
    if (currentRouteName) {
      localStorage.setItem(
        common.storageVariables.currentRoute,
        currentRouteName.toString()
      );
    }
    eventBus.on("toggle-enrollments-menu", (data) => {
      this.menuItems = this.originalMenuItems.slice();
      const totalEnrollments = Number(this.getTotalEnrollments) || 0;
      if (this.menuItems[0].link == "enrollments" && totalEnrollments <= 1) {
        this.menuItems.splice(0, 1);
      }
      const enrollment = JSON.parse(
        sessionStorage.getItem(common.storageVariables.enrollment) || "{}"
      );
      // Remove last item if serviceType === 1
      if (
        enrollment?.serviceType === 1 &&
        this.menuItems.length > 0 &&
        this.menuItems[this.menuItems.length - 1].link == "payments"
      ) {
        this.menuItems.splice(this.menuItems.length - 1, 1);
      }
    });
  },
  mounted() {
    eventBus.on("toggle-stripe-menu", (data) => {
      if (data) {
        const cardDetails = this.menuItems.find(
          (item) => item.link === "card-details"
        );
        if (!cardDetails) {
          this.menuItems.push({
            link: "card-details",
            title: "Credit/Debit Card",
            icon: "card-details",
            priority: 8,
          });
          this.isPaymentCard = true;
        }
      } else {
        this.isPaymentCard = false;
        this.menuItems.splice(this.menuItems.length, 1);
      }
    });

    if (sessionStorage.getItem(common.storageVariables.paymentMethod)) {
      this.menuItems.push({
        link: "card-details",
        title: "Card details",
        icon: "card-details",
        priority: 8,
      });
      this.isPaymentCard = true;
    }
  },
  methods: {
    ...mapMutations(["setFormDirty", "setClearTheInterval"]),
    async navigateTo(link: string): Promise<void> {
      if (
        this.getFormDirty &&
        !window.confirm(
          "You have unsaved changes. Are you sure you want to leave?"
        )
      ) {
        return;
      }
      this.setFormDirty(false);
      this.$router.push({ name: link });
    },
    toggleMenu(): void {
      this.showMobileMenu = !this.showMobileMenu;
    },
    getActiveClass(priority: number) {
      // Find the index of the current route in the visible menu
      const visibleMenu = this.visibleMenuItems;
      const currentIndex = visibleMenu.findIndex(
        (item) => this.$route.name === item.link
      );
      const stepIndex = visibleMenu.findIndex(
        (item) => item.priority === priority
      );

      // Get current pageStep as index in visible menu
      const pageStep =
        sessionStorage.getItem(common.storageVariables.pageStep) ?? 0;
      const allBenefitsWaived = sessionStorage.getItem(
        common.storageVariables.allBenefitsWaived
      );
      if (
        allBenefitsWaived === "true" &&
        (priority === common.pageStep.payments ||
          priority === common.pageStep.documents)
      ) {
        return false;
      }
      // If currentIndex is -1, fallback to old logic
      if (currentIndex === -1 || stepIndex === -1) {
        return priority <= Number(pageStep);
      }
      // Mark as active if this is the current step or a previous step
      return stepIndex <= currentIndex;
    },
    async logout() {
      if (this.getFormDirty && !window.confirm(messages.dirtyFormCheckMsg)) {
        return;
      }
      TokenService.logout();
      this.setClearTheInterval();
      this.setFormDirty(false);
      this.$router.push({ name: routesPath.getStarted });
    },
  },
});
